import React, { useState, useEffect, useRef } from 'react';
import { SkillsPopup } from '../SkillsPopup';
import { SkillSliderContent } from '../SkillSliderContent';
import { useMediaQuery } from 'react-responsive';
import { inIframe } from '../../utils';

interface SkillSliderProps {
  skills: any[];
  searchTerm?: string;
  refreshSkills?: (skills: any[]) => void;
}

export const SkillSlider: React.FC<SkillSliderProps> = ({
  skills,
  refreshSkills,
  searchTerm,
}) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [filteredSkills, setFilteredSkills] = useState(skills);
  const sliderRef = useRef<any>(null);
  const isMobile = useMediaQuery({ maxWidth: 579 });
  const isMedium = useMediaQuery({ minWidth: 580, maxWidth: 1024 });

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 400,
    slidesToShow: isMobile
      ? 1
      : isMedium
      ? 2
      : skills?.length >= 4
      ? 4
      : skills?.length,
    slidesToScroll: 1,
    vertical: false,
    centerMode: false,
    centerPadding: '0',
    arrows: false,
  };

  const handleSkillClick = (skill) => {
    setSelectedSkill(skill);
    setPopupOpen(true);
  };

  const closePopup = () => {
    setSelectedSkill(null);
    setPopupOpen(false);
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current?.slickPrev();
    }
  };

  useEffect(() => {
    if (searchTerm?.trim() === '') {
      setTimeout(() => {
        setFilteredSkills(skills);
        handlePrev();
      }, 1000);
    } else {
      const filtered = skills.filter((skill) =>
        skill?.name && String(skill.name).toLowerCase().includes(searchTerm?.toLowerCase() || '')
      );
      setFilteredSkills(filtered);
    }
  }, [searchTerm, skills]);

  return (
    <>
      <div className="br_row">
        <SkillSliderContent
          skills={filteredSkills}
          handleSkillClick={handleSkillClick}
          sliderSettings={sliderSettings}
          ref={sliderRef}
        />
        {isPopupOpen && selectedSkill && !inIframe() && (
          <SkillsPopup
            skillsData={selectedSkill}
            allSkills={skills}
            closePopUp={closePopup}
            refreshSkills={refreshSkills}
          />
        )}
      </div>
    </>
  );
};
